import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";

import _FM_EzeeroomtypesFormComponent from "../components/_FM_ezee/_FM_EzeeroomtypesDndComponent";
import _FM_EzeelogListComponent from "../components/_FM_ezee/_FM_EzeelogListComponent";
import _FM_EzeesettingsFormComponent from "../components/_FM_ezee/_FM_EzeesettingsFormComponent";
import axios from "axios";
import Cookies from "js-cookie";
import {Dropdown} from "primereact/dropdown";
import HelpComponent from "../components/HelpComponent";
import {Card} from "primereact/card";
import {Sidebar} from "primereact/sidebar";
import _FM_ReceiptShowComponent from "../components/_FM_receipt/_FM_ReceiptShowComponent";
import _FM_EzeelogShowComponent from "../components/_FM_ezee/_FM_EzeelogShowComponent";

const _FM_EzeePage = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id} = useParams();
  const [accommodation, setAccommodation] = useState([]);
  const selectedAccommodationId = Number(id) || null;

  const setAccommodationRoute = (_accommodationId, replace = false) => {
    const numericId = Number(_accommodationId);
    if (!numericId) {
      return;
    }
    localStorage.setItem('selectedAccommodation', String(numericId));
    window.App.setState({
      rerenderEzeesettingsForm: Math.random(),
      rerenderEzeeroomtypesDnd: Math.random(),
    });
    navigate('/ezee/' + numericId, {replace});
  };


  useEffect(() => {
    document.title = t('ezee_settings') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/ezee')
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        const accommodations = response.data.data.items;
        setAccommodation(accommodations);
        if (!accommodations[0]) {
          return;
        }
        if (!selectedAccommodationId) {
          const fallbackAccommodationId = Number(localStorage.getItem('selectedAccommodation'))
            || accommodations?.[0]?.id;
          if (fallbackAccommodationId) {
            setAccommodationRoute(fallbackAccommodationId, true);
          }
        } else {
          const routeAccommodationExists = accommodations.some((item) => Number(item.id) === selectedAccommodationId);
          if (!routeAccommodationExists) {
            setAccommodationRoute(accommodations[0].id, true);
            return;
          }
          localStorage.setItem('selectedAccommodation', String(selectedAccommodationId));
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [selectedAccommodationId]);

  return (
    <div className="_FM_EzeePage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/ezee"}/>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-col-align-center p-text-right"}>
          <HelpComponent type={"site"} position={"UNDER_HELP_BUTTON"}/>
          <Dropdown options={accommodation}
                    optionLabel="name"
                    optionValue="id"
                    className={"p-ml-2 p-text-left"}
                    id={"accommodation"}
                    emptyMessage={t('empty_message')}
                    onChange={(e) => {
                      setAccommodationRoute(e.value)
                    }}
                    value={selectedAccommodationId}
          />
        </div>
      </div>
      {selectedAccommodationId && (
        <>
          <div className={"p-grid col-borders"}>
            <div className={"p-col-12 p-lg-4"} style={{display: 'flex', flexDirection: 'column'}}>
              <Card className={"p-m-0 p-shadow-0 p-p-0"} style={{flex: 1}}>
                <_FM_EzeesettingsFormComponent accommodationId={selectedAccommodationId}
                                               onAccommodationChange={setAccommodationRoute}/>
              </Card>
            </div>
            <div className={"p-col-12 p-lg-8"} style={{display: 'flex', flexDirection: 'column'}}>
              <Card className={"p-my-0 p-shadow-0"} style={{flex: 1}}>
                <_FM_EzeeroomtypesFormComponent accommodationId={selectedAccommodationId}
                                                onAccommodationChange={setAccommodationRoute}/>
              </Card>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12"}>
              <Panel>
                <_FM_EzeelogListComponent accommodationId={selectedAccommodationId}/>
              </Panel>
            </div>
          </div>
        </>
      )}
      <Sidebar position="right" visible={window.App.urlVars().read === 'log' && window.App.urlVars().logId} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1);
               }}>
        <_FM_EzeelogShowComponent/>
      </Sidebar>

    </div>
  )
}
export default withTranslation('common')(_FM_EzeePage);
